import SpaceDashboardIcon from '@mui/icons-material/SpaceDashboard';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import GroupsIcon from '@mui/icons-material/Groups';
import { AppShell, type NavItem } from './AppShell';
import { useNotificationsPoller } from '../hooks/useNotificationsPoller';

const NAV: NavItem[] = [
  { label: 'Dashboard', to: '/admin', icon: <SpaceDashboardIcon /> },
  { label: 'Approvals', to: '/admin/approvals', icon: <FactCheckIcon /> },
  { label: 'Clients', to: '/admin/clients', icon: <GroupsIcon /> },
];

export function AdminLayout() {
  // Toast new admin notifications (new trade requests, etc.) as they arrive.
  useNotificationsPoller();
  return <AppShell nav={NAV} badge="Admin" />;
}
